import { checkIsMaintenanceMode } from '../helpers/downForMaintenance';
import { logout } from './api';
import { setAuthorizationExpiresTimeout, updateIsMaintenanceMode } from './slices';

const API_ROOT_URI = `${process.env.REACT_APP_API_URL}`;

export async function client(
  endpoint,
  { body, method, dispatch, ...customConfig } = {},
) {
  const headers = {
    'Authorization-SetAsCookie': 'true',
    'Content-Type': 'application/json',
    'Client': 'dashboard',
    'Cache-Control': 'no-store, no-cache, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0',
  };

  const config = {
    method: method || 'GET',
    ...customConfig,
    headers: {
      ...headers,
      ...customConfig.headers,
    },
    credentials: 'include',
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  let data;
  try {
    const response = await window.fetch(`${API_ROOT_URI}${endpoint}`, config);
    data = await response.json();

    if (response.status === 500 && data.errorCode === 2000) {
      dispatch && dispatch(logout());
    }
    if (response.headers.has('Authorization-Expires')) {
      dispatch && dispatch(setAuthorizationExpiresTimeout(response.headers.get('Authorization-Expires')));
    }

    if (response.status === 410) {
      window.location.href = '/login#logout';
    }

    if (!response.ok) {
      const response = await checkIsMaintenanceMode();
      if (response.status === 200) {
        dispatch && dispatch(updateIsMaintenanceMode(true));
      }
    }

    return {
      data,
      status: response.status,
      ok: response.ok,
    };
  } catch (err) {
    return Promise.reject(err.message ? err.message : data);
  }
}

client.get = function(endpoint, body = {}, customConfig = {}) {
  return client(endpoint, { ...customConfig, method: 'GET', dispatch: customConfig.dispatch });
};

client.post = function(endpoint, body, customConfig = {}) {
  return client(endpoint, { ...customConfig, body, method: 'POST', dispatch: customConfig.dispatch });
};

client.put = function(endpoint, body, customConfig = {}) {
  return client(endpoint, { ...customConfig, body, method: 'PUT', dispatch: customConfig.dispatch });
};

client.patch = function(endpoint, body, customConfig = {}) {
  return client(endpoint, { ...customConfig, body, method: 'PATCH', dispatch: customConfig.dispatch });
};

client.delete = function(endpoint, body, customConfig = {}) {
  return client(endpoint, { ...customConfig, body, method: 'DELETE', dispatch: customConfig.dispatch });
};

export const apiCallWithRetry = async (apiCall, retries = 3, delay = 1000) => {
  let attempts = 0;
  while (attempts < retries) {
    try {
      return await apiCall(); // Attempt the API call
    } catch (error) {
      attempts++;
      if (attempts >= retries) throw error; // Throw error after max retries
      await new Promise((resolve) => setTimeout(resolve, delay + attempts)); // Delay before retry
    }
  }
};
